import React from 'react'
import { Route, Link } from 'react-router-dom'
import axios from 'axios'
import Show from './../components/show'

class Shows extends React.Component {
	constructor(props){
		super(props)

		this.state = {
			items: []
		}
	}

	componentDidMount(){
		this.fetchData()
	}

	fetchData(){
		axios.get('https://dhsetheatre-api.madebypeppernet.com//api-admin.php', {
			params: {
				filename: 'shows',
				preview: 'true',
			}
		}).then( response => {
			this.setState({
				items: response.data.items.sort( (a,b) => {
					if(a.performance_dates && a.performance_dates.length && b.performance_dates && b.performance_dates.length){
						if(a.performance_dates[0].date < b.performance_dates[0].date){
							return 1
						}
						if(a.performance_dates[0].date > b.performance_dates[0].date){
							return -1
						}
						return 0
					}
					return 0
				})
			})
		})
	}

	handleAddNewItem(){
		// Create the new item.
		const items = this.state.items

		// Generate a new id.
		const id = items.reduce( (id, item) => {
			if(item.id >= id){
				id = parseInt(item.id, 10) + 1
			}
			return id
		}, 0)

		// Add the new item to the list.
		items.push({
			id: id,
			title: 'new show ' + id
		})

		// Save it to state.
		this.setState({ items })

		// Execute a call to the API to create a new show.
		// Create the data to store.
		var data = {
			items: this.state.items,
		}

		// Save the items to the API.
		axios({
			method: 'POST',
			url: 'https://dhsetheatre-api.madebypeppernet.com//api-admin.php',
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			data: {
				filename: 'shows',
				content: JSON.stringify(data)
			}
		})
	}

	render() {
		return (
			<section className="shows container show_grid">
				<Route exact path="/shows" component = { (props) => {
					return (
						<div>
							<h2>Shows</h2>
							<button className="add button" onClick={this.handleAddNewItem.bind(this)}>Add New Show</button>
							<div className="grid">
								{this.state.items.map( (item) => {
									return (
										<Link className="thumb" key={item.id} to={`${this.props.match.url}/${item.id}`}>
											<h3>{decodeURIComponent(item.title)}</h3>
											{ item.thumb ?
												<img src={decodeURIComponent(item.thumb)} alt={decodeURIComponent(item.title)} /> :
												null
											}
										</Link>
										)
								})}
							</div>
						</div>
						)
				}} />

				<Route path={`${this.props.match.url}/:showId`} component={ (props) => {
					return <Show id={`${props.match.params.showId}`} />
				}} />
			</section>
		)
	}
}

export default Shows



// WEBPACK FOOTER //
// ./src/pages/shows.js